import React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import RemoveIcon from "@mui/icons-material/Remove";
import ReadOnlyTextField from "../../../common/ReadOnlyTextField";

const styles = {
  operatorBox: {
    display: "flex",
    width: "56px",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "30px",
    height: "56px",
  },
  infoIcon: {
    color: "#1976d2",
    fontSize: "24px",
    ml: 1,
  },
};

export default function QuantityRow({
  value,
  label,
  operator = null,
  onInfoClick,
  showInfoButton = true,
}) {
  const getOperatorContent = () => {
    switch (operator) {
      case "minus":
        return <RemoveIcon />;
      case "equals":
        return "=";
      default:
        return null;
    }
  };

  return (
    <Box display="flex" alignItems="center">
      <Box sx={styles.operatorBox}>{getOperatorContent()}</Box>
      <ReadOnlyTextField
        value={value}
        label={label}
        InputLabelProps={{
          shrink: true,
        }}
      />
      {showInfoButton ? (
        <IconButton sx={styles.infoIcon} onClick={onInfoClick}>
          <InfoOutlinedIcon />
        </IconButton>
      ) : (
        <Box sx={{ width: "60px" }} />
      )}
    </Box>
  );
}
